import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hub-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss']
})
export class ImageViewerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
